module.exports = __webpack_public_path__ + "static/media/banner2.d1b7618f.jpg";